import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';
import { cacheInterceptor } from './core/interceptors/cache.interceptor-fn';
import { AuthService } from './core/services/auth.service';
import { provideLucideIcons } from './core/icons/lucide-icons.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([cacheInterceptor])),
    // IHUB v2 host-match: register the Lucide icons used by the redesigned (.ihx) UI
    ...provideLucideIcons(),
    provideAnimations(),
    provideTranslateService({
      defaultLanguage: 'lo'
    }),
    provideTranslateHttpLoader({
      prefix: '/assets/i18n/',
      suffix: '.json'
    }),
    // Record an ihub app-open as soon as the app boots — covers deep-link / direct
    // super-app entry where the ih_phone cookie is already present. Fire-and-forget;
    // recordAppOpen() dedupes per session and is also called from setUserPhone().
    provideAppInitializer(() => { inject(AuthService).recordAppOpen(); })
  ]
};
